/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab } from "../../clients/courseRegistrationEnrollmentController/putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";

export const putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationKey =
  () =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/selective-process-tab",
      },
    ] as const;

export type PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationKey =
  ReturnType<
    typeof putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationKey
  >;

export function putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationKey();
  return mutationOptions<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
    >,
    {
      courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"];
      data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ courseRegistrationId, data }) => {
      return putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab(
        courseRegistrationId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Atualiza status, tipo de admissão, datas de vestibular e entrevista, flags de presença e aprovação de documentação, motivo de rejeição e notas do processo seletivo. As notas são informadas na escala 0–10 e armazenadas divididas por 10. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Salva os dados do processo seletivo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/selective-process-tab}
 */
export function usePutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
      ResponseErrorConfig<
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
      >,
      {
        courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"];
        data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationKey();

  const baseOptions =
    putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationOptions(
      config,
    ) as UseMutationOptions<
      PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
      ResponseErrorConfig<
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
        | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
      >,
      {
        courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"];
        data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
    >,
    {
      courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"];
      data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
    >,
    {
      courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"];
      data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest;
    },
    TContext
  >;
}
